import get from 'lodash.get';

const getBlockTemplates = (rootState) => get(rootState, 'ws.template.meta.blockTemplates', []);

export default getBlockTemplates;
